<template>

    <section class="group-statistics">

        <div class="panel">
            <div class="panel-heading"><h2>Week</h2></div>
            <div class="panel-body">
                <div class="form-group">
                    <select class="form-control" @change="getGroupInfo($event.target.value); getAttendance($event.target.value)" >
                        <option v-for="week in weeks" :value="week">Week {{week}}</option>
                    </select>
                </div>
                    <ul class="videos" v-if="videos">
                         <li v-for="video in videos">
                            <h4>{{getVideo(video.id).course.name}} &mdash; {{video.title}} &mdash; Week {{video.week}}</h4>
                            <ul class="progresses clearfix">
                                <li v-for="progress in video.progresses">
                                    <div class="col-xs-12 col-md-2 text-right nopad">
                                        {{progress.firstName}} {{progress.lastName}}
                                    </div>
                                    <div class="col-xs-11 col-md-9 nopad">
                                    <span class="progress"
                                        v-bind:style="{ width: getProgress(progress.progress, video.totalDuration) + '%' }">
                                    </span>
                                </div>
                                </li>
                            </ul>
                            <h5 v-if="video.exercise">Exercise</h5>

                            <div v-if="video.exercise">
                                {{video.exercise.title}}: [{{studentHandinsCount(video.exercise.exercise_hand_ins)}} / {{students.length}}]

                                <div v-for="hand_in in video.exercise.exercise_hand_ins" class="hand-in">
                                    <b>{{hand_in.studentName || hand_in.userId}}</b>
                                    <div v-for="file in hand_in.url">
                                        <a :href="file" target="_blank">{{file | filenameFromUrl}}</a>
                                    </div>
                                </div>

                                <h6>These people need help:</h6>
                                <ul class="needs-help" v-if="video.exercise.exercise_hand_ins.length > 0">
                                    <li v-for="student in helpNeeded(video.exercise.exercise_hand_ins)">
                                        {{student.name}}
                                    </li>
                                </ul>



                            </div>

                            <div v-if="video.assignments.length > 0">
                                <h5>Assignment: {{video.assignments[0]['assignment.name']}} [{{video.assignments.length}} / {{students.length}}]</h5>
                                <div v-for="hand_in in video.assignments" class="hand-in">
                                    <b>{{hand_in.studentName || hand_in.userId}}</b>
                                    <div v-for="file in hand_in.url">
                                        <a :href="file" target="_blank">{{file | filenameFromUrl}}</a>
                                    </div>
                                </div>

                            </div>
                           <!--  <div v-if="video.assignment && video.assignment.length > 0">
                                <h5>Assignment</h5>
                                 <p v-for="a in video.assignment">
                                    {{getVideo(video.id).course.name}} - [{{a.name}} <span v-if="a.student_info">{{numberSubmitted(a.student_info)}}</span> / {{students.length}} Submitted]
                                    [<span v-if="a.student_info">{{numberMarked(a.student_info)}}</span> / {{students.length}} Marked]
                                </p>
                            </div> -->
                        </li>
                </ul>
            </div>
        </div>

        <div class="panel">
            <div class="panel-heading"><h2>Meeting Attendance</h2></div>
            <div class="panel-body">
                <table class="table table-striped table-bordered attendance">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Time in Meeting</th>
                            <th>Attentiveness</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="student in attendance">
                            <td>{{student.name}}</td>
                            <td>{{Math.round(student.duration / 60)}} minutes</td>
                            <td><span v-if="student.attentivenessScore">{{student.attentivenessScore.toFixed(2)}}%</span></td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
        <div class="panel">
            <div class="panel-heading">
                <h4>
                    Meeting Archives
                </h4>
            </div>
            <div class="panel-body">
                <ul class="unstyled meetings">
                    <li v-for="meeting in meetings">
                        <div>{{meeting.startTime | longDate}}</div>
                        <div v-if="meeting.archiveStatus === 'completed'">
                            <a :href="meeting.archiveUrl" target="_blank">Play Recording</a>
                            <span v-if="meeting.secondaryRecordings && meeting.secondaryRecordings.length > 0">
                                (
                                <a :href="meeting.archiveUrl" target="_blank">1</a>
                                <span v-for="(recording, index) in meeting.secondaryRecordings">,
                                    <a :href="recording" target="_blank"> {{ index + 2 }} </a>
                                </span>)
                            </span>
                        </div>
                        <div v-else>Recording not ready</div>
                    </li>
                </ul>
            </div>
        </div>
    </section>

</template>


<script>
    import terms from '../services/terms';
    import students from '../services/students';
    import exercises from '../services/exercises';
    import assignments from '../services/assignments';
    import meetings from '../services/meetings';
    import courses from '../services/courses';

    import moment from 'moment';
    import _ from 'underscore';

    export default {
        data() {
            return {
                weeks:null,
                currentWeek: null,
                groupLabel: null,
                statistics: null,
                videos: [],
                numberOfStudents: null,
                myCourses: null,
                attendance: null,
                meetings:null,
                students: []
            }
        },
        mounted() {
            this.$store.dispatch('toggle',{type:'loading', boolean: true});

            this.groupId = this.$route.params.groupId;
            this.groupLabel = this.$route.params.groupLabel;
            this.termId = this.$route.params.term;

            this.getCurrentTerm();
            this.getExercises();
            this.getCourses();
            meetings.get(this, this.groupId).then((response)=>{
                this.meetings = response.data.meetings;
            })
        },
        methods: {
            getCourses() {
                var self = this;
                courses.getInstructorCourses().then(function(response) {
                    self.myCourses = response.data;
                });
            },
            helpNeeded(handins) {
                var self = this;
                return handins.filter(function(h) {
                    if (h && h.assessment === 1) {
                        let index = self.students.findIndex(function(s) { return s.id === h.userId});
                        h.name = self.students[index].name;
                        return h;
                    }
                })
            },
            getExercises() {
                var self = this;
                exercises.getAll(this).then(function(response) {
                   // console.log(response);
                });
            },
            numberSubmitted: function(student_info) {
                if (!Array.isArray(student_info)) student_info = [student_info];
                return student_info.filter(function(s){ return s.submitted_assignment_data != '0'}).length
            },
            numberMarked: function(student_info) {
                if (!Array.isArray(student_info)) student_info = [student_info];
                return student_info.filter(function(s){ return s.grade }).length
            },
            getProgress(watched, total) {
                var progress =  ( ( (Math.round(watched) / total) * 100).toFixed(2) );
                if (progress > 100) progress = 100;
                return progress;
            },
            getVideo(videoId) {
                let index = this.videos.findIndex(function(v) { return v.id === videoId});
                if (index > -1) return this.videos[index];
                return false;
            },

            getAttendance(week) {
                var self = this;
                self.attendance = null;
                var start = moment(this.$store.getters.currentTerm.startDate).add(week - 1,'weeks').startOf('week');
                var end = moment(start).endOf('week');
                meetings.getAttendance(this, this.groupId, start.toDate(), end.toDate()).then(function(response) {

                    var data = response.data.report;
                    let students = [];
                    if (!data.participants) return;
                    data.participants.forEach(function(p) {
                        let index = students.findIndex(function(s) { return s.name == p.name});
                        if (p.attentivenessScore) p.attentivenessScore = p.attentivenessScore.replace('%','');

                        if (index === -1) {
                            students.push({
                                name: p.name,
                                duration: p.duration,
                                attentivenessScore: parseFloat(p.attentivenessScore)
                            })
                        } else {
                            students[index].duration += p.duration;
                            students[index].attentivenessScore = (parseFloat(students[index].attentivenessScore) + parseFloat(p.attentivenessScore)) / 2;
                        }
                    });
                    self.attendance = students;

                }).catch((e)=>{
                    console.log(e)
                    self.attendance = [];
                })
            },
            studentHandinsCount(handins) {
                const studentIds = [];
                for (let handin of handins) {
                    if (!studentIds.includes(handin.userId)) studentIds.push(handin.userId)
                }
                return studentIds.length;
            },
            getGroupInfo(week) {
                var self = this;
                self.$store.dispatch('toggle',{type:'loading', boolean: true});

                self.videos = [];
                self.students = [];
                self.statistics = null;

                students.getGroupInfo(this, this.groupId, week, this.termId).then(function(response) {
                    var data = response.data;
                    var groupSize = data.length;

                    function calculateProgress(videoData) {
                        videoData.forEach(function(d) {
                            d.response.progresses.forEach(function(p) {

                                let i = self.videos.findIndex(function(v) { return v.id === p.videoId});
                                if (i > -1) {
                                    let user = self.videos[i].progresses.findIndex(function(u) {
                                        return u.userId === p.userId
                                    });

                                    if (user === -1)  {
                                        self.videos[i].progresses.push({
                                            userId: p.userId,
                                            progress: p.progress,
                                            firstName: d.response.first,
                                            lastName: d.response.last
                                        })
                                    }
                                    else {
                                        self.videos[i].progresses[user].progress += p.progress;
                                    }
                                }

                            });
                        })
                    }


                    function getAssignments() {
                        self.videos.forEach(function(video) {
                        let instanceIndex = self.myCourses.findIndex(function(c) { return c.associated.name === video.course.name} );
                        let instanceId = self.myCourses[instanceIndex].id;

                        assignments.get(self, instanceId, week).then(function(response) {
                            let i = self.videos.findIndex(function(v) { return v.id === video.id});
                            if (response.data.length > 1) {
                                // response.data = response.data.filter(function(a, index, self) {
                                //     return index === self.findIndex(function(b) {
                                //         return a.student_info && b.student_info
                                //     })
                                // });
                                response.data = response.data.filter((a, index, self) =>
                                      index === self.findIndex((b) => (
                                        a.student_info && b.student_info && b.student_info.student_id === a.student_info.student_id
                                      )))
                            }

                            self.$set(self.videos[i], 'assignment', response.data);
                            }).catch(function(e) {
                                console.log(e);
                            });
                        });
                    }


                    data.forEach(function(d, i) {

                        self.students.push({
                            name: d.response.first + ' ' + d.response.last,
                            id: d.response.tttoId
                        });

                        d.response.videos.forEach(function(video){

                            let index = self.videos.findIndex(function(v) { return v.id === video.id})

                            if (index === -1) {
                                video.totalDuration = video.video_chapters.map(function(d) {
                                    return d.duration;
                                }).reduce(function(a, b) { return a + b; });

                                video.progresses = [];

                                video.assignments = [];

                                self.videos.push(video);

                                index = self.videos.findIndex(function(v) { return v.id === video.id})

                            }

                            if (d.response.assignments) {

                                const thisWeeksAssignments = d.response.assignments.filter((a)=>{
                                    return a['assignment.week'] === self.videos[index].week && a.instanceId === self.videos[index].instanceId
                                }).map((a)=>{
                                    a.studentName = d.response.first + ' ' + d.response.last;
                                    return a;
                                })
                                self.videos[index].assignments = self.videos[index].assignments.concat(thisWeeksAssignments)
                            }

                            if (self.videos[index].exercise) {
                                if (d.response.first === 'lucas') {
                                }
                                let handins = video.exercise.exercise_hand_ins.map((v) => {
                                    v.studentName = d.response.first + ' ' + d.response.last;
                                    return v;
                                })

                                for (let handin of handins) {
                                    let exists = self.videos[index].exercise.exercise_hand_ins.find(i => i.id === handin.id);
                                    if (!exists) self.videos[index].exercise.exercise_hand_ins.push(handin);
                                }
                            }

                            if ((i + 1)=== data.length) {
                                getAssignments();
                                calculateProgress(data);
                            }
                        });

                    });


                    var statistics = {
                        posts: data.map(function(d) { return d.response.posts}).reduce(function(a, b) { return a + b}),
                        chatMessages: data.map(function(d) { return d.response.chatMessages}).reduce(function(a, b) { return a + b}),
                        tickets: data.map(function(d) { return d.response.tickets}).reduce(function(a, b) { return a + b}),
                    }
                    self.statistics = statistics;
                    self.$store.dispatch('toggle',{type:'loading', boolean: false});

                });
            },
            getCurrentTerm() {
                var self = this;
                terms.get(this).then(function(response) {
                    let term = response.data.terms.filter(function(t) { return t.id == self.$route.params.term})[0];


                    var data = {
                        type: 'currentTerm',
                        data: term
                    }
                    self.$store.dispatch('populate', data);

                    self.getWeeks();

                });
        },
        getWeeks() {
                var self = this;
                var term = this.$store.state.currentTerm;
                var weeks = moment(term.endDate).diff(moment(term.startDate),'week');
                var startDate = moment(term.startDate).startOf('day').format('YYYY-MM-DD');

                var pst = moment().tz('America/Vancouver').format('YYYY-MM-DD');

                var currentWeek = moment(pst).diff(moment(startDate), 'weeks');
                currentWeek = 1;
                this.currentWeek = currentWeek;
                this.weeks = weeks;

                var checkCoursesLoaded = setInterval(function() {
                    if (self.myCourses) {
                        self.getGroupInfo(currentWeek);
                        self.getAttendance(currentWeek);
                        clearInterval(checkCoursesLoaded);
                    }
                },2000)

            },
        },

    }

</script>

<style lang="scss" scoped>
.meetings {
    li {
        display:flex;
        padding:1.4rem 1rem;
        border-bottom:1px solid #464545;
        align-items:center;
        justify-content:space-between;

    }
}
.hand-in {
    margin-top:.5rem;
    margin-bottom:1rem;
}
.progresses {
    margin-top:2rem;
    .col-md-2 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    li {
        margin-bottom: 10px;
        padding-bottom: 0;
        p {
            margin:0;
        }
    }
}
.progress {
    display:inline-block;
    height:15px;
    background: #42b983;
    margin-bottom:0;
    text-align: center;
    color: #fff;
    font-size: 1rem;
    border-radius:0;
    margin-left:2px;
    position:relative;
    top:2px;
}

.attendance {
    td {
        max-width:200px;
    }
}

@media screen and (min-width: 769px) {
    .videos > li {

        padding:1rem;
        &:nth-child(odd) {
            background: #2e2e2e;
        }
    }
}
</style>



// WEBPACK FOOTER //
// GroupStatistics.vue?53ab214c